import { useMutation } from '@apollo/client'
import {
  MarkMaterializedProcessAsCompletedDocument,
  MaterializedProcessDocument,
} from 'generated/resources/graphql'

export const useMarkAsCompletedMaterializedProcessWithoutDataTableVariables = () => {
  const [executeMutation] = useMutation(MarkMaterializedProcessAsCompletedDocument)
  const markAsCompletedMaterializedProcess = async (id: string) => {
    const { data, errors } = await executeMutation({
      variables: {
        id,
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: MaterializedProcessDocument,
          variables: {
            id: id,
          },
        },
      ],
    })

    if (
      errors?.length ||
      data?.processesMutations?.markAsCompletedProcessesMaterializedProcess?.errors.length
    ) {
      throw (
        'Could not mark process as completed:: ' +
        JSON.stringify([
          ...(errors || []),
          ...(data?.processesMutations?.markAsCompletedProcessesMaterializedProcess?.errors || []),
        ])
      )
    }
  }

  return {
    markAsCompletedMaterializedProcess,
  }
}
